import React from "react";
import { Quotation } from "../../../../../stores/CoursePreviewStore/Types";
import AppliedVoucher from "../AppliedVoucher";
import PriceAmount from "../PriceAmount";
import ThoughtLeadersPhoto from "../ThoughtLeadersPhoto";

interface Props {
  activeQuote: Quotation;
  couponCode: string;
  refCode: string;
  refreshQuoteWithoutCoupon: (e: any) => void;
  // A member upgrading from the Pass, who has renewals and invoices to retire.
  forMember?: boolean;
}

const Lifetime: React.FC<Props> = ({
  activeQuote,
  couponCode,
  refCode,
  refreshQuoteWithoutCoupon,
  forMember = false,
}) => {
  return (
    <>
      <h3>Your plan</h3>
      <ThoughtLeadersPhoto />
      <div className="plan-header">
        <div className="plan-details">
          <h4 id="planTitle">Lifetime All Access</h4>
          <p id="planSubtitle">One payment. Every course. Forever.</p>
        </div>
      </div>

      <div id="priceBreakdown">
        <div className="price-line">
          <span>Lifetime All Access</span>
          <PriceAmount quote={activeQuote} />
        </div>
        <div className="price-line">
          <span>Billing</span>
          <span>One-off, never again</span>
        </div>
        <AppliedVoucher
          couponCode={couponCode}
          refCode={refCode}
          refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        />
        <div className="price-line total">
          <span>Today's charge</span>
          <div className="price-right">
            <PriceAmount quote={activeQuote} />
            <div className="discount-note" style={{ color: "#C4841D" }}>
              Pay once
            </div>
          </div>
        </div>
      </div>

      <div className="whats-included" id="whatsIncluded">
        <h4>What you get</h4>
        <ul>
          <li>Every course, current and future</li>
          <li>Mini MBA certificates, all of them</li>
          <li>Community Hub access, for life</li>
          <li>AI toolkit and swipe file</li>
          <li>
            {forMember
              ? "No more renewals, no more invoices"
              : "One payment, no renewals, ever"}
          </li>
        </ul>
      </div>
      <div className="roi-block" id="roiBlock">
        <h4>For comparison</h4>
        <p>
          Less than <strong>2%</strong> of the cost of a Harvard MBA.
        </p>
      </div>
    </>
  );
};

export default Lifetime;
